import React, { PropsWithChildren } from 'react';
import { Box } from '@mui/material';
import { Navbar } from 'components/Navbar/Navbar';

export const ContainerLayout = ({ children }: PropsWithChildren) => (
  <Box height="100dvh" overflow="hidden">
    <Navbar />
    {children}
  </Box>
);
